const DEFAULT_OBJECT = {};

export const getReportsStore = (store) => store?.reports || DEFAULT_OBJECT;
